import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { GettingStartedPage } from '@/components/getting-started-page';

const searchBoolean = z.preprocess((value) => {
  if (typeof value === 'string') {
    const normalized = value.trim().toLowerCase();
    if (normalized === 'true') return true;
    if (normalized === 'false') return false;
  }
  return value;
}, z.boolean());

const gettingStartedSearchSchema = z.object({
  success: searchBoolean.optional(),
  canceled: searchBoolean.optional(),
  plan: z.enum(['pro', 'business']).optional(),
  interval: z.enum(['monthly', 'yearly']).optional(),
});

export const Route = createFileRoute('/getting-started')({
  validateSearch: gettingStartedSearchSchema,
  component: GettingStartedRoute,
});

function GettingStartedRoute() {
  const { success, canceled, plan, interval } = Route.useSearch();

  return (
    <GettingStartedPage
      success={success}
      canceled={canceled}
      initialPlan={plan}
      initialInterval={interval}
    />
  );
}
